import { Mapper } from "../../../../base/utils/mapper";
import { DataBasicProfileModel } from "../../../../domain/models/user/data-basic-profile.model";
import { DataBasicProfileEntity } from "../entities/data-basic-profile.entity";

export class DataBasicProfileImplementationRepositoryMapper extends Mapper<DataBasicProfileEntity, DataBasicProfileModel> {
    mapFrom(param: DataBasicProfileEntity): DataBasicProfileModel {
        return {
            PrimerNombre: param.PrimerNombre,
            SegundoNombre: param.SegundoNombre,
            PrimerApellido: param.PrimerApellido,
            SegundoApellido: param.SegundoApellido,
            IdPais: param.IdPais
        };
    }
    mapTo(param: DataBasicProfileModel): DataBasicProfileEntity {
        return {
            PrimerNombre: param.PrimerNombre,
            SegundoNombre: param.SegundoNombre,
            PrimerApellido: param.PrimerApellido,
            SegundoApellido: param.SegundoApellido,
            IdPais: param.IdPais
        };
        }
    }

